import React from 'react'
import { Control, Controller } from 'react-hook-form'
import FormControl from '@mui/material/FormControl'
import { FormHelperText } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import dayjs from 'dayjs'

type Props = DatePickerProps<any> & {
  name: string
  control: Control | any
  errorMessage?: string | null
  label?: string
  required?: boolean
  value?: string
  onClear?: boolean
  onAction?: (value?: any) => void
}

export function FormInputDatePicker ({ name, control, label, errorMessage, required = false, value, onClear, onAction, ...rest }: Props) {
  const handleAction = (value: any) => {
    if (onAction) {
      onAction(value)
    }
  }
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={(value ? dayjs(value) : '')}
      render={({ field: { onChange, value }, fieldState: { invalid } }) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FormControl fullWidth error={invalid} required={required}>
            <div className="customDatePickerWidth">
              <DatePicker
                {...rest}
                onChange={(value) => {
                  onChange(value)
                  handleAction(value)
                }}
                value={(value ? dayjs(value) : '')}
                label={label}
                format="DD/MM/YYYY"
                className={errorMessage ? 'myDatePicker' : undefined}
                slotProps={{
                  actionBar: { actions: (onClear ? ['clear', 'cancel', 'accept'] : ['cancel', 'accept']) }
                }}
              />
              {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
            </div>
          </FormControl>
        </LocalizationProvider>
      }} />
  )
}
